import toaster, { Theme } from '../../toaster';

export const showGeneralErrorToaster = (message: string) => {
  toaster.error(message, { theme: Theme.New });
};
